import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("fisco_cookie_consent")) setVisible(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem("fisco_cookie_consent", value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-md z-[60] bg-white border border-[#C4C8CC]/60 rounded-2xl shadow-[0_8px_32px_rgba(10,17,40,0.15)] p-6">
      <div className="flex items-start gap-3">
        <Cookie size={22} strokeWidth={1.5} className="text-[#0A1128] mt-0.5 shrink-0" />
        <div>
          <p className="text-sm text-[#374151] leading-relaxed">
            Nous utilisons des cookies pour améliorer votre expérience et analyser le trafic, conformément au RGPD.{" "}
            <Link to="/politique-de-confidentialite" className="underline text-[#0A1128]">En savoir plus</Link>
          </p>
          <div className="flex gap-3 mt-4">
            <button data-testid="cookie-accept-btn" onClick={() => decide("accepted")} className="text-sm font-semibold text-white bg-[#0A1128] rounded-full px-5 py-2 hover:bg-[#1A2342] transition-colors duration-200">
              Accepter
            </button>
            <button data-testid="cookie-refuse-btn" onClick={() => decide("refused")} className="text-sm font-medium text-[#4B5563] border border-[#C4C8CC] rounded-full px-5 py-2 hover:bg-[#F8F9FA] transition-colors duration-200">
              Refuser
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
